module.exports = __webpack_public_path__ + "8cc79f4b8ed2b5e2a688c8e329c87029.png";